/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UnitProperty
 */
export interface UnitProperty {
    /**
     * 
     * @type {string}
     * @memberof UnitProperty
     */
    property: string;
    /**
     * 
     * @type {string}
     * @memberof UnitProperty
     */
    unitId: string;
}

/**
 * Check if a given object implements the UnitProperty interface.
 */
export function instanceOfUnitProperty(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "property" in value;
    isInstance = isInstance && "unitId" in value;

    return isInstance;
}

export function UnitPropertyFromJSON(json: any): UnitProperty {
    return UnitPropertyFromJSONTyped(json, false);
}

export function UnitPropertyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnitProperty {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'property': json['property'],
        'unitId': json['unitId'],
    };
}

export function UnitPropertyToJSON(value?: UnitProperty | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'property': value.property,
        'unitId': value.unitId,
    };
}

